import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/home-bg-visa.jpg")